(function () {
  var cache = Object.create(null);
  var navigating = false;
  var SLIDE_MS = 560;
  var POST_NAV_VIDEO_MS = 480;
  var postNavVideoTimer = 0;
  var postNavIdleId = 0;

  function isDesignMode() {
    return !!(window.Shopify && Shopify.designMode);
  }

  function genderLinks(root) {
    return Array.from((root || document).querySelectorAll('[data-hole-gender-switch]'));
  }

  function prefetch(url) {
    if (!url || cache[url]) return;
    cache[url] = fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('prefetch failed');
        return response.text();
      })
      .then(function (html) {
        cache[url] = html;
        return html;
      })
      .catch(function () {
        delete cache[url];
      });
  }

  function getHtml(url) {
    var hit = cache[url];
    if (typeof hit === 'string') return Promise.resolve(hit);
    if (hit && typeof hit.then === 'function') return hit;
    return fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('navigate failed');
        return response.text();
      })
      .then(function (html) {
        cache[url] = html;
        return html;
      });
  }

  function syncBodyClass(doc) {
    var next = doc.body ? doc.body.className : '';
    if (!next) return;
    document.body.className = next
      .replace(/\bhole-gender-sliding\b/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function syncTitle(doc) {
    if (doc.title) document.title = doc.title;
    var canonical = document.querySelector('link[rel="canonical"]');
    var nextCanonical = doc.querySelector('link[rel="canonical"]');
    if (canonical && nextCanonical && nextCanonical.href) canonical.href = nextCanonical.href;
  }

  function revealSectionFades() {
    document.querySelectorAll('#MainContent [class*="js-animation-"]').forEach(function (el) {
      el.classList.add('animation-init', 'animation-none');
    });
  }

  function isEffectivelyHidden(el) {
    if (!el || !el.isConnected) return true;
    var node = el;
    while (node && node.nodeType === 1 && node !== document.documentElement) {
      var style = window.getComputedStyle(node);
      if (style.display === 'none' || style.visibility === 'hidden') return true;
      node = node.parentElement;
    }
    return false;
  }

  function clearVideoSources(video) {
    video.removeAttribute('src');
    Array.from(video.querySelectorAll('source')).forEach(function (source) {
      source.remove();
    });
    try {
      video.load();
    } catch (error) {
      // ignore
    }
  }

  function hardKillVideos(root) {
    if (!root) return;
    root.querySelectorAll('video').forEach(function (video) {
      try {
        video.pause();
      } catch (error) {
        // ignore
      }
      clearVideoSources(video);
      video.removeAttribute('autoplay');
      delete video.dataset.holeSrc;
      delete video.dataset.holeSources;
      delete video.dataset.holeAutoplay;
      delete video.dataset.holeDisarmed;
    });
  }

  function disarmVideo(video) {
    if (!video) return;

    try {
      video.pause();
    } catch (error) {
      // ignore
    }

    if (!video.dataset.holeDisarmed) {
      var src = video.getAttribute('src');
      if (src) {
        video.dataset.holeSrc = src;
      }

      var sources = Array.from(video.querySelectorAll('source'));
      if (sources.length) {
        video.dataset.holeSources = JSON.stringify(
          sources.map(function (source) {
            return {
              src: source.getAttribute('src'),
              type: source.getAttribute('type')
            };
          })
        );
      }

      if (video.hasAttribute('autoplay') || video.autoplay) {
        video.dataset.holeAutoplay = '1';
        video.removeAttribute('autoplay');
        video.autoplay = false;
      }

      video.dataset.holeDisarmed = '1';
    }

    clearVideoSources(video);
  }

  function armVideo(video) {
    if (!video || !video.dataset.holeDisarmed) return;

    if (video.dataset.holeSrc) {
      video.setAttribute('src', video.dataset.holeSrc);
      delete video.dataset.holeSrc;
    }

    if (video.dataset.holeSources) {
      try {
        JSON.parse(video.dataset.holeSources).forEach(function (item) {
          if (!item || !item.src) return;
          var source = document.createElement('source');
          source.setAttribute('src', item.src);
          if (item.type) source.setAttribute('type', item.type);
          video.appendChild(source);
        });
      } catch (error) {
        // ignore
      }
      delete video.dataset.holeSources;
    }

    delete video.dataset.holeDisarmed;

    try {
      video.load();
    } catch (error) {
      // ignore
    }
  }

  function disarmVideos(root) {
    if (!root) return;
    root.querySelectorAll('video').forEach(disarmVideo);
  }

  function killHiddenHeroVideos(root) {
    var scope = root || document;
    scope.querySelectorAll('video').forEach(function (video) {
      if (!isEffectivelyHidden(video)) return;
      try {
        video.pause();
      } catch (error) {
        // ignore
      }
      clearVideoSources(video);
      video.removeAttribute('autoplay');
      delete video.dataset.holeSrc;
      delete video.dataset.holeSources;
      delete video.dataset.holeAutoplay;
      delete video.dataset.holeDisarmed;
    });
  }

  function cancelPostNavVideoBoot() {
    if (postNavVideoTimer) {
      window.clearTimeout(postNavVideoTimer);
      postNavVideoTimer = 0;
    }
    if (postNavIdleId && window.cancelIdleCallback) {
      window.cancelIdleCallback(postNavIdleId);
      postNavIdleId = 0;
    }
  }

  function bootVisibleVideos(root) {
    var scope = root || document.querySelector('#MainContent') || document;
    scope.querySelectorAll('video').forEach(function (video) {
      if (isEffectivelyHidden(video)) {
        try {
          video.pause();
        } catch (error) {
          // ignore
        }
        clearVideoSources(video);
        video.removeAttribute('autoplay');
        delete video.dataset.holeSrc;
        delete video.dataset.holeSources;
        delete video.dataset.holeAutoplay;
        delete video.dataset.holeDisarmed;
        return;
      }

      var shouldPlay = video.dataset.holeAutoplay === '1' || video.dataset.holeDisarmed === '1';

      if (video.dataset.holeDisarmed) {
        armVideo(video);
      }

      if (video.dataset.holeAutoplay === '1') {
        video.setAttribute('autoplay', '');
        video.autoplay = true;
        delete video.dataset.holeAutoplay;
      }

      if (!shouldPlay) return;

      video.muted = true;
      video.setAttribute('muted', '');
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    });
  }

  function schedulePostNavVideoBoot(root) {
    cancelPostNavVideoBoot();

    var ready = false;
    function run() {
      if (ready) return;
      ready = true;
      postNavVideoTimer = 0;
      postNavIdleId = 0;
      bootVisibleVideos(root);
    }

    // Delay HD decode/play until after settle paint — cold-load stays untouched.
    postNavVideoTimer = window.setTimeout(run, POST_NAV_VIDEO_MS);
  }

  function deferHeavySections(panel) {
    if (!panel) return;
    Array.from(panel.children).forEach(function (child, index) {
      if (index === 0) return;
      child.setAttribute('data-hole-deferred-section', '1');
      child.style.contentVisibility = 'hidden';
      child.style.containIntrinsicSize = 'auto 600px';
    });
  }

  function restoreDeferredSections(root) {
    if (!root) return;
    root.querySelectorAll('[data-hole-deferred-section]').forEach(function (child) {
      child.removeAttribute('data-hole-deferred-section');
      child.style.contentVisibility = '';
      child.style.containIntrinsicSize = '';
    });
  }

  function teardownInteractive(root) {
    if (!root) return;

    hardKillVideos(root);

    root
      .querySelectorAll('hero-slider, swiper-component, card-product-slider')
      .forEach(function (el) {
        if (typeof el.destroy === 'function') {
          el.destroy();
          return;
        }
        if (el.slider && typeof el.slider.destroy === 'function') {
          try {
            el.slider.destroy(true, true);
          } catch (error) {
            // ignore
          }
          el.slider = null;
        }
        if (el.swiper && typeof el.swiper.destroy === 'function') {
          try {
            el.swiper.destroy(true, true);
          } catch (error) {
            // ignore
          }
          el.swiper = null;
          el.swiperInitialized = false;
        }
      });
  }

  function directionFromLink(link) {
    if (!link) return 'left';
    if (link.classList.contains('hole-gender-switch--left')) return 'right';
    return 'left';
  }

  function directionFromUrl(url) {
    try {
      var path = new URL(url, window.location.origin).pathname.replace(/\/$/, '');
      if (/\/pages\/kadin$/i.test(path)) return 'left';
      return 'right';
    } catch (error) {
      return 'left';
    }
  }

  function finish(main, panelIn, panelOut, doc, url, push) {
    teardownInteractive(panelOut);
    // Incoming stays disarmed (poster only) until delayed boot.
    disarmVideos(panelIn);

    document.dispatchEvent(new CustomEvent('hole:gender-before-swap'));

    document.body.classList.remove('hole-gender-sliding');
    document.documentElement.classList.remove('hole-gender-nav');

    main.textContent = '';
    while (panelIn.firstChild) main.appendChild(panelIn.firstChild);

    restoreDeferredSections(main);
    syncTitle(doc);
    syncBodyClass(doc);
    window.scrollTo(0, 0);
    document.documentElement.classList.add('is-at-top');
    document.body.classList.add('is-at-top');
    document.body.classList.remove('is-scrolled');
    document.documentElement.classList.add('hole-gender-settled');

    if (push) history.pushState({ holeGender: 1 }, '', url);

    revealSectionFades();
    bootPrefetch();
    killHiddenHeroVideos(main);
    schedulePostNavVideoBoot(main);
    document.dispatchEvent(new CustomEvent('hole:gender-switched', { detail: { url: url } }));
    navigating = false;
  }

  function slideSwap(html, url, push, dir) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var nextMain = doc.querySelector('#MainContent');
    var main = document.querySelector('#MainContent');
    if (!nextMain || !main) {
      window.location.assign(url);
      return;
    }

    cancelPostNavVideoBoot();

    var top = main.getBoundingClientRect().top;
    // Viewport-tall stage only — full-page stage was compositing ~2x page height on mobile.
    var height = Math.max(1, window.innerHeight - Math.max(top, 0));

    document.documentElement.classList.add('hole-gender-nav');
    document.body.classList.add('hole-gender-sliding');

    var stage = document.createElement('div');
    stage.className = 'hole-gender-stage';
    stage.style.height = height + 'px';

    var track = document.createElement('div');
    track.className = 'hole-gender-track';

    var panelOut = document.createElement('div');
    panelOut.className = 'hole-gender-panel';
    while (main.firstChild) panelOut.appendChild(main.firstChild);
    // Outgoing page: hard kill media so decode buffers are released.
    hardKillVideos(panelOut);
    deferHeavySections(panelOut);

    var panelIn = document.createElement('div');
    panelIn.className = 'hole-gender-panel';
    Array.from(nextMain.childNodes).forEach(function (node) {
      panelIn.appendChild(document.importNode(node, true));
    });
    // Incoming: keep sources parked — poster only during the slide.
    disarmVideos(panelIn);
    deferHeavySections(panelIn);

    if (dir === 'left') {
      track.appendChild(panelOut);
      track.appendChild(panelIn);
      track.style.transform = 'translate3d(0,0,0)';
    } else {
      track.appendChild(panelIn);
      track.appendChild(panelOut);
      track.style.transform = 'translate3d(-50%,0,0)';
    }

    stage.appendChild(track);
    main.appendChild(stage);

    var done = false;
    function complete() {
      if (done) return;
      done = true;
      finish(main, panelIn, panelOut, doc, url, push);
    }

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        track.classList.add('is-animating');
        track.style.transform = dir === 'left' ? 'translate3d(-50%,0,0)' : 'translate3d(0,0,0)';
      });
    });

    track.addEventListener('transitionend', function onEnd(event) {
      if (event.target !== track || event.propertyName !== 'transform') return;
      track.removeEventListener('transitionend', onEnd);
      complete();
    });

    window.setTimeout(complete, SLIDE_MS + 80);
  }

  function navigate(url, push, dir) {
    if (navigating || !url) return;
    var shouldPush = push !== false;
    if (shouldPush && url === window.location.href) return;
    navigating = true;
    cancelPostNavVideoBoot();

    getHtml(url)
      .then(function (html) {
        try {
          slideSwap(html, url, shouldPush, dir || directionFromUrl(url));
        } catch (error) {
          window.location.assign(url);
        }
      })
      .catch(function () {
        window.location.assign(url);
      });
  }

  function bootPrefetch() {
    genderLinks().forEach(function (link) {
      prefetch(link.href);
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest('[data-hole-gender-switch]');
      if (!link) return;
      if (isDesignMode()) return;
      if (event.defaultPrevented) return;
      if (event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      event.stopPropagation();
      navigate(link.href, true, directionFromLink(link));
    },
    true
  );

  document.addEventListener(
    'pointerenter',
    function (event) {
      var link = event.target.closest('[data-hole-gender-switch]');
      if (link) prefetch(link.href);
    },
    true
  );

  document.addEventListener(
    'touchstart',
    function (event) {
      var link = event.target.closest('[data-hole-gender-switch]');
      if (link) prefetch(link.href);
    },
    { capture: true, passive: true }
  );

  window.addEventListener('popstate', function () {
    if (isDesignMode()) return;
    if (!document.querySelector('[data-hole-gender-switch]')) return;
    navigate(window.location.href, false, directionFromUrl(window.location.href));
  });

  // Cold load / resize: only kill hidden desktop hero videos. Do not touch cold autoplay.
  function bootHiddenVideoCleanup() {
    killHiddenHeroVideos(document);
  }

  window.addEventListener('resize', function () {
    window.clearTimeout(bootHiddenVideoCleanup._timer);
    bootHiddenVideoCleanup._timer = window.setTimeout(bootHiddenVideoCleanup, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bootPrefetch();
      bootHiddenVideoCleanup();
    });
  } else {
    bootPrefetch();
    bootHiddenVideoCleanup();
  }

  window.addEventListener('load', function () {
    bootPrefetch();
    bootHiddenVideoCleanup();
  });
})();
